import script from "./RichTextFieldSmall.vue?vue&type=script&setup=true&lang=ts"
export * from "./RichTextFieldSmall.vue?vue&type=script&setup=true&lang=ts"

import "./RichTextFieldSmall.vue?vue&type=style&index=0&id=62163556&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62163556"]])

export default __exports__